import { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../components/Layout";

const Creatures = () => {
  const [creatureList, setCreatureList] = useState("");

  useEffect(() => {
    getCreatures();
  }, []);

  const getCreatures = () => {
    axios
      .get(
        "https://creatureparty.net/dashboard/wp-json/creatureparty/v1/creatures"
      )
      .then((res) => setCreatureList(res.data))
      .catch((err) => console.log(err));
  };

  return (
    <Layout>
      <section className="Creatures">
        <div className="Creatures__List">
          {creatureList
            ? creatureList.map((creature, i) => {
                return (
                  <div className="Creatures__Item" key={`creature${i}`}>
                    {creature.img && (
                      <div className="Creatures__Image">
                        <a href={`/creatures/${creature.id}`}><img src={creature.img.medium} /></a>
                      </div>
                    )}
                    <div className="Creatures__Description">
                      <a href={`/creatures/${creature.id}`}>
                        <p className="Creatures__Name">{creature.name}</p>
                        {creature.attended && creature.attended.party && (
                          <p className="Creatures__Party">{creature.attended.party}</p>
                        )}
                      </a>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      </section>
    </Layout>
  );
};

export default Creatures;
